import {
    faChevronDown,
    faChevronUp,
    faClose,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderLogo from '../../images/EnglanderVector.svg';
import { LocalizedLink } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React from 'react';
import { replaceWhiteSpace } from '../../utils';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

interface IObjectMenu {
    title: string;
    link: string;
    isLitteral?: boolean;
}

export default function Sidenavmenu(props: {
    states: any;
    accessories: Map<any, any>;
    ventings: Map<any, any>;
    closeSidenav: any;
}) {
    const { states, accessories, ventings, closeSidenav } = props;
    const { t } = useTranslation('layout');
    const { navigateTranslated } = usePageLocalization();
    const sidenavMenuData = {
        [t('menu-titles.appliances')]: {
            'wood-stoves': {
                title: t('header.wood-stoves'),
                link: '/heaters/wood-stoves/',
            },

            'outdoor-fireplaces': {
                title: t('header.outdoor-fireplaces'),
                link: '/heaters/outdoor-fireplaces/',
            },
            'camp-stoves': {
                title: t('header.camp-stoves'),
                link: '/heaters/camp-stoves/',
            },
        },
        [t('menu-titles.ventings')]: Array.from(ventings)[0][1]
            .sort((a: any, b: any) => a.label > b.label)
            .map(
                (single: { label: string; slug: string; category: string }) => {
                    const category = replaceWhiteSpace(
                        single.category.split('/')[3].toLowerCase(),
                        '-'
                    );
                    return {
                        title: single.label,
                        link: `/venting/${category}/`,
                        isLitteral: true,
                    };
                }
            ),
        [t('menu-titles.accessories')]: Array.from(accessories)[0][1]
            .sort((a: any, b: any) => a.label > b.label)
            .map((single: { label: string; slug: string }) => {
                return {
                    title: single.label,
                    link: single.slug,
                    isLitteral: true,
                };
            }),
        [t('menu-titles.replacement-parts')]: {
            title: 'empty',
            link: '/archives/',
        },
        [t('menu-titles.support-service')]: {
            'where-to-buy': {
                title: t('menu-titles.where-to-buy'),
                link: '/where-to-buy/',
            },
            warranty: {
                title: t('menu-titles.warranty'),
                link: '/warranty/wood-stoves/',
            },
            contact: {
                title: t('menu-titles.contact'),
                link: '/contact/',
            },
            about: {
                title: t('menu-titles.about'),
                link: '/about/',
            },
            'gov-incentives': {
                title: t('menu-titles.gov-incentives'),
                link: '/gov-incentives/',
            },
            manuals: {
                title: t('menu-titles.manuals'),
                link: '/archives/',
            },
            videos: {
                title: t('menu-titles.videos'),
                link: '/videos/',
            },
            faq: {
                title: t('menu-titles.faq'),
                link: '/faq/wood-stoves/',
            },
            blog: {
                title: t('menu-titles.blog'),
                link: '/blogArchives/',
            },
        },
    };

    const getTopLevelNavLink = (category: string, index: number): void => {
        const isOpen = states?.[index]?.isOpen;
        switch (category) {
            case t('menu-titles.appliances'):
                navigateTranslated('/heaters/');
                props.closeSidenav();
                break;
            case t('menu-titles.accessories'):
                navigateTranslated('/accessories/');
                props.closeSidenav();
                break;
            case t('menu-titles.ventings'):
                navigateTranslated('/venting/');
                props.closeSidenav();
                break;
            case t('menu-titles.support-service'):
                states?.[index]?.setIsOpen(!isOpen);
                break;
            default:
                break;
        }
    };

    return (
        <div className='navbar'>
            <div className='navbar-header'>
                <FontAwesomeIcon
                    onClick={() => closeSidenav()}
                    className='navbar-close'
                    icon={faClose}
                />
                <LocalizedLink to='/' className='header-logo'>
                    <img
                        src={HeaderLogo}
                        alt='Englander Logo'
                        onClick={() => closeSidenav()}
                    />
                </LocalizedLink>
            </div>

            {Object.entries(sidenavMenuData).map((menuData, index: number) => {
                const isOpen = states?.[index]?.isOpen;
                return (
                    <div
                        key={index}
                        className='subnav'
                        onClick={() => {
                            getTopLevelNavLink(menuData[0], index);
                        }}
                    >
                        <div className={`nav-title ${isOpen && 'open'}`}>
                            {!isEmpty() ? (
                                <>
                                    <span className='title '>
                                        {menuData[0]}
                                    </span>
                                    <FontAwesomeIcon
                                        className={`icon ${isOpen && 'open'}`}
                                        icon={
                                            isOpen ? faChevronUp : faChevronDown
                                        }
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            states?.[index]?.setIsOpen(!isOpen);
                                        }}
                                    />
                                </>
                            ) : (
                                <LocalizedLink
                                    className='title no-sub-menu'
                                    to={menuData[1].link ?? '#'}
                                    label={menuData[0]}
                                />
                            )}
                        </div>

                        {isOpen && (
                            <div className='nav-items'>
                                {Object.values(menuData[1]).map(
                                    (
                                        objectMenu: IObjectMenu | any,
                                        index: number
                                    ) => {
                                        return (
                                            <LocalizedLink
                                                key={index}
                                                className='nav-item'
                                                onClick={() =>
                                                    (document.body.style.overflow =
                                                        'scroll')
                                                }
                                                to={objectMenu?.link}
                                                label={
                                                    objectMenu?.isLitteral
                                                        ? `${objectMenu?.title}`
                                                        : objectMenu?.title
                                                }
                                            />
                                        );
                                    }
                                )}
                            </div>
                        )}
                    </div>
                );

                function isEmpty() {
                    return menuData?.[1]?.title === 'empty';
                }
            })}
        </div>
    );
}
